import type { FormRule } from 'antd';
import type { Dayjs } from 'dayjs';
import { isSafeIntValidator } from 'shared/utils/validators/is-safe-integer-validator';
import type { IWhTaskFormFields } from './types';

const validateDate = (_: unknown, value: Dayjs | [Dayjs, Dayjs]) => {
  if (!value) {
    return Promise.reject("'date' is required");
  }
  return Promise.resolve();
};

export const validationRules: Record<keyof IWhTaskFormFields, FormRule[]> = {
  type: [{ required: true, type: 'string' }],
  client: [{ required: true, type: 'object' }],
  contact: [{ required: true, type: 'object' }],
  warehouseId: [{ required: true, type: 'number' }],
  totalWeight: [{ required: true, type: 'integer', min: 0 }, ...isSafeIntValidator('Total weight')],
  clientOrderNumber: [{ required: false, type: 'string' }],
  warehouseTaskItems: [{ required: true, type: 'array' }],
  plateNumberFrom: [{ required: false, type: 'string' }],
  plateNumberTo: [{ required: false, type: 'string' }],
  date: [{ required: true, validator: validateDate }],
  currency: [{ required: false, type: 'string' }],
  freight: [{ required: true, type: 'number', min: 1 }],
  additionalInfo: [{ required: false, type: 'string' }],
  fineToUs: [{ required: false, type: 'number', min: 0 }],
  fineByUs: [{ required: false, type: 'number', min: 0 }],
  realArrivalDate: [{ required: false, type: 'string' }],
  realDepartureDate: [{ required: false, type: 'string' }],
};
